// import './assets/main.css'
import './assets/oplanet.css';
import App from './App.vue';
import router from './router';
import { createApp } from 'vue';
import { i18n } from './localization';
import Tooltip from 'primevue/tooltip';

const app = createApp(App)

// import { createPinia } from 'pinia'
// app.use(createPinia())

app.use(router)
app.use(i18n)
app.directive('tooltip', Tooltip);

app.mount('#app')
